import {
  Dialog, DialogActions, DialogContent, DialogTitle, Typography,
} from '@mui/material';
import { useState } from 'react';

import Button from 'components/ui/Button';

const AlertDialog = ({
  isOpen,
  onClose,
  onSubmit,
  title,
  text,
  agreeButtonText = 'Agree',
  buttonSx = {}
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    setIsLoading(true);

    await onSubmit();

    setIsLoading(false);

    onClose();
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{ p: 3 }}
      fullWidth>
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      {text && (
        <DialogContent>
          <Typography variant="body2">{text}</Typography>
        </DialogContent>
      )}

      <DialogActions sx={{ pr: 2.5 }}>
        <Button onClick={onClose} color="error">
          Close
        </Button>
        <Button
          disabled={isLoading}
          sx={buttonSx}
          variant="contained"
          size="small"
          onClick={handleSubmit}
          isLoading={isLoading}>
          {agreeButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AlertDialog;
